import {SubmitOnce} from "../../components/submit-once";
import DirectionsMapComponent from "../components/directions-map-component";

export default class RequestARideSummaryController {

  constructor() {
    new SubmitOnce();

    new DirectionsMapComponent($('#rideMapComponent')).autoSet();
    new DirectionsMapComponent($('#returnRideMapComponent')).autoSet();
  }
}
